import React, { useEffect } from "react";
import { connectOpenBets } from "./OpenBets.connect";
import OpenBetsList from "../OpenBetsList/OpenBetsList";
import { useLocation } from "react-router-dom";

const OpenBets = ({
  timeSettings,
  openBets,
  redirect,
  isEvent,
  id,
  auth,
  actions,
  mobileUIonAll = false,
}) => {
  const location = useLocation();

  useEffect(() => {
    let locationCheck =
      location.pathname === "/" || location.pathname.includes("event-page");
    !locationCheck && auth && actions.requestOpenBets();

    const interval = setInterval(() => {
      if (!locationCheck && auth) {
        actions.requestOpenBets();
      }
    }, 30000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [location, auth]);

  return (
    <div id={id} title="Open Bets">
      <div className=" flex flex-col w-full  gap-1">
        <OpenBetsList
          bets={openBets}
          timeSettings={timeSettings}
          isEvent={isEvent}
          redirect={redirect}
          title="Matched Bets"
          mobileUIonAll={mobileUIonAll}
        />
      </div>
    </div>
  );
};

export default connectOpenBets()(OpenBets);
